var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-info"},[_c('div',{staticClass:"icon-data home-border"},_vm._l((_vm.defaultList),function(item,index){return _c('div',{key:index,staticClass:"icon-list",on:{"click":function($event){return _vm.gotoTemp(item)}}},[_c('div',{staticClass:"icon-image",style:(item.style)}),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }